import { ComputeWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Compute')
export class ComputeNodeConnectorProvider extends ConnectorProvider<ComputeWorkflowNode> {}
